import { matchPath } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';

import { DetailPageKind } from './types';

export const getDetailPageKind = (pathname: string): DetailPageKind | null => {
  const detailRoutes: Array<{ kind: DetailPageKind; path: string }> = [
    { kind: 'noteCreate', path: ROUTES.organization.notebook.notes.createNote.path },
    { kind: 'noteEdit', path: ROUTES.organization.notebook.notes.note.edit.path },
    { kind: 'note', path: ROUTES.organization.notebook.notes.note.path },
    { kind: 'insightCreate', path: ROUTES.organization.notebook.insights.createInsight.path },
    { kind: 'insightEdit', path: ROUTES.organization.notebook.insights.insight.edit.path },
    { kind: 'insight', path: ROUTES.organization.notebook.insights.insight.path },
    { kind: 'followUpCreate', path: ROUTES.organization.notebook.followUps.createFollowUp.path },
    { kind: 'followUpEdit', path: ROUTES.organization.notebook.followUps.followUp.edit.path },
    { kind: 'followUp', path: ROUTES.organization.notebook.followUps.followUp.path },
    { kind: 'news', path: ROUTES.organization.news.article.path },
  ];

  const match = detailRoutes.find(({ path }) => matchPath({ path, end: true }, pathname));

  return match?.kind ?? null;
};

export const getIsDetailsPage = (pathname: string): boolean => {
  return getDetailPageKind(pathname) !== null;
};
